module.exports = __webpack_public_path__ + "3b32ce6ebe93acddd682bf79f232592d.png";